import { Link } from "react-router-dom";

import styled from "styled-components";

import logoLong from "../assets/logo-long-image.png";

const HeaderSection = () => (
  <Container>
    <LogoContainer>
      <Link to="/">
        <Logo src={logoLong} alt="Logo for Amazing Flips" />
      </Link>
    </LogoContainer>

    <PhoneNumberContainer>
      <a href="tel:6022629464">602-262-9464</a>
    </PhoneNumberContainer>
  </Container>
);

export default HeaderSection;

const Container = styled.div`
  max-width: 1232px;

  margin-left: auto;

  margin-right: auto;

  padding: 1rem;

  display: grid;

  gap: 0.5rem;

  @media (min-width: 560px) {
    padding: 2rem;

    display: flex;

    justify-content: space-between;
  }

  width: 100%;
`;

const LogoContainer = styled.div`
  display: grid;

  justify-content: center;
`;

const Logo = styled.img`
  max-width: 200px;

  @media (min-width: 400px) {
    max-width: 300px;

    @media (min-width: 800px) {
      max-width: 250px;
    }
  }
`;

const PhoneNumberContainer = styled.div`
  display: flex;

  flex-direction: column;

  justify-content: center;

  a {
    @media (min-width: 400px) {
      font-size: 1.5rem;

      @media (min-width: 560px) {
        font-size: 2rem;

        @media (min-width: 800px) {
          font-size: 2.5rem;
        }
      }
    }

    text-align: center;

    text-decoration: none;

    color: #283878;

    &:hover {
      font-weight: 600;
    }
  }
`;
